import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
    FormBuilder,
    FormGroup,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { NgIf } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { AuthService } from '../../core/auth/auth.service';
import { TranslocoModule } from '@ngneat/transloco';
import {
    RecaptchaV3Module,
    ReCaptchaV3Service,
} from 'ng-recaptcha';

@Component({
    selector: 'app-sign-in',
    standalone: true,
    imports: [
        RouterLink,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatCheckboxModule,
        ReactiveFormsModule,
        NgIf,
        TranslocoModule,
        RecaptchaV3Module,
    ],
    templateUrl: './sign-in.component.html',
    styleUrl: './sign-in.component.scss',
})
export class SignInComponent {
    recapchaService = inject(ReCaptchaV3Service);
    // isToggled
    isToggled = false;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        public themeService: CustomizerSettingsService,
        private authService: AuthService,
    ) {
        this.authForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required]],
        });
        this.themeService.isToggled$.subscribe((isToggled) => {
            this.isToggled = isToggled;
        });
    }

    // Password Hide
    hide = true;

    // Form
    authForm: FormGroup;

    // Show alert
    showAlert: boolean = false;

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * On submit
     */
    onSubmit(): void {
        // Return if the form is invalid
        if (this.authForm.invalid) {
            this.showAlert = false;
            return;
        }

        // Disable the form
        this.authForm.disable();

        // Hide the alert
        this.showAlert = false;

        // Recapcha V3
        this.recapchaService.execute('login').subscribe(
            (token) => {
                // Sign in
                let login = {email: this.authForm.get('email')?.value,
                    password: this.authForm.get('password')?.value,
                    recaptcha: token
                }
                this.authService.signIn(login).subscribe(
                    () => {
                        // Navigate to the redirect url
                        this.router.navigateByUrl('/authentication/mfa-login');
                    },
                    (response) => {
                        // Re-enable the form
                        this.authForm.enable();

                        // Show the alert
                        this.showAlert = true;
                    }
                );
            },
            (error) => {
                console.log(`Recaptcha v3 error:`, error);
            }
        );
    }

    // Dark Mode
    toggleTheme() {
        this.themeService.toggleTheme();
    }

    // Card Border
    toggleCardBorderTheme() {
        this.themeService.toggleCardBorderTheme();
    }

    // RTL Mode
    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }

    // onKeydown
    onKeydown(event: Event) {
        //console.log(event);
        return false;
    }
}
